import { ReactComponent as RefreshIcon } from '@apps/gated-2021/assets/refresh-cw.svg';
import React from 'react';
import { Button } from './button';

export const RetryAddressButton: React.FC<{ onRetry: () => void }> = ({ onRetry }) => {
    return (
        <Button color="yellow" variant={'link'} onClick={onRetry}>
            <RefreshIcon />
            <span>Try a different address</span>
        </Button>
    );
};
